import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";

const Aaccountstatement = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="bg-[#f0ece1] fixed_width h-[100vh] flex  accounts_main">
        <div className="left w-[20%]">
          <div className="restore_indisde_heading ml-3 mt-5 rounded-sm  bg-gradient-to-t from-blue-900 to-blue-950">
            <p className="text-white  ml-2 font-bold p-1">Positions</p>
          </div>
          <div className="w-[98%]  ml-2">
            <ul>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/Aaccountstatement"}>Account Statement</Link>
              </li>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/Aaccountstatement"}>Account Summaary</Link>
              </li>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                Activity Log
              </li>
            </ul>
          </div>
          <div className="restore_indisde_heading ml-3  rounded-sm  bg-gradient-to-t from-blue-900 to-blue-950">
            <p className="text-white  ml-2 font-bold p-1">Accounts Details</p>
          </div>
          <div className="w-[98%]  ml-2">
            <ul>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/Aaccountstatement"}>Profile </Link>
              </li>
              <li className=" bg-white border-none py-1 hover:bg-gray-400  font-normal text-[15px]">
                <Link to={"/ActivityLog"}>Activity log </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="right w-[70%]">
          <div className="account_main   mt-5 ">
            <div className="balance_overview   ml-5 ">
              <div className="account_profile mt-3">
                <div className="main_account">
                  <h2 className=" p-1 ml-1 text-black font-bold">
                    Account Summary
                  </h2>
                  <div className="bg-[#fff] border-b-2 border-[#498daf] shadow-md p-4">
                    <h2 className="font-bold ">Your Balances</h2>
                    <h2 className="font-bold text-[25px] text-[#498daf]">
                      17.68
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aaccountstatement;
